import prod from './prod.store';
import dev from './dev.store';
import config from '../config/config.json';

export default config.deploymentEnv === 'prod' ? prod : dev;
